import { observer } from 'mobx-react';
import { ImportedParticipantsResource } from '../../../../Store/Types';
import AddParticipantsToGroupFormStore from '../Store';
import { Ready, ReadyToSubmit } from '../Store/Types';
import GroupForm from './GroupForm';
import GroupLabel from './GroupLabel';

interface Props {
  successfulParticipantsResource: ImportedParticipantsResource;
  addParticipantsToGroupFormStore: AddParticipantsToGroupFormStore;
  addParticipantsGroupFormState: Ready | ReadyToSubmit;
}

function GroupFormState({
  successfulParticipantsResource,
  addParticipantsToGroupFormStore,
  addParticipantsGroupFormState,
}: Props) {
  switch (addParticipantsGroupFormState.kind) {
    case 'ready':
      return (
        <GroupForm
          successfulParticipantsResource={successfulParticipantsResource}
          addParticipantsToGroupFormStore={addParticipantsToGroupFormStore}
        />
      );
    case 'ready-to-submit':
      return (
        <GroupLabel
          addParticipantsToGroupFormStore={addParticipantsToGroupFormStore}
          group={addParticipantsGroupFormState.group}
        />
      );
  }
}

export default observer(GroupFormState);
